import { PerformancePayload } from "containers/performance/types";
import { Client } from "./config";

export function FetchPerformance(student_id: string) {
  return Client.get<PerformancePayload>(
    `/data/second_graph?userID=${student_id}`
  );
}
